export const danishCountryCodeString = '(\\+|00)45';
export const danishCountryCode = new RegExp(`^${danishCountryCodeString}`);